import {
  ChangeDetectorRef, ChangeDetectionStrategy,
  Component, Input, ViewChild, ElementRef,
} from '@angular/core';
import * as _ from 'lodash';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { SearchFormComponent } from 'shared/search/search-form/search-form.component';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { BrandService } from 'shared/brand/brand.service';
import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';

import { columns } from './columns';


@Component({
  moduleId: module.id,
  selector: 'pricing-sheet-search',
  templateUrl: 'pricing-sheet-search.component.html',
  styleUrls: ['pricing-sheet-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingSheetSearchComponent extends FrontendSearchWidgetComponent {

  @Input() noSearchForm: boolean = false;
  @Input() searchValue: string = '';
  @Input() isVersion2: boolean = false;

  @ViewChild('searchResultsContainer', {static: false}) searchResultsContainer: ElementRef | void;
  @ViewChild('searchForm', {static: false}) declare searchForm: SearchFormComponent;

  columns: any = columns;
  sortingColumns: any = [];
  searchFilterField: string = 'price_sheet_name_number';
  ghostValue: string = 'pricing-sheet-search';

  constructor(
    protected ref: ChangeDetectorRef,
    private priceSheetService: PriceSheetService,
    private brandService: BrandService,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isEmpty() {
    return !this.data || !this.data.length;
  }

  // redefine method
  get searchTermValue(): any {
    return this.searchForm ? this.searchForm.searchTermValue : this.searchValue;
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public init() {
    this.fetchPriceSheets();
  }

  public destroy() {
    this.resetData();
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private fetchPriceSheets() {
    this.priceSheetService.fetchAll(this.brandService.getBrand())
    .subscribe((data: any) => {
      this.data = data;
      this.addColToData(this.searchFilterField);
      this.ref.markForCheck();
    });
  }
}
